import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import MarkedField from 'scoreboard/components/marked-field'

/**
 * Centralizes password confirmation validation behaviors.
 * Preconditions:
 *  - A form input named 'password'
 *  - A form input named 'confirmPassword'
 */
var passwordValidation = {

	/**
	 * @param {jQuery} form a jquery object representing the form containing the
	 * password inputs
	 * @param {Boolean} [options.required=true] If a password is not required, pass false
	 * @return {array} of MarkedField objects
	 */
	markFields: function(form, options = {required: true}) {
		var marks = []
		const validator = options.required ? [requiredValidator] : []
		marks.push(new MarkedField({
			el: form.$('[name=password]'),
			validator
		}).render())
		// only verify passwords match when bluring on the password confirmation.
		// we don't want to show two errors, and we don't want to show an error
		// when first moving from the password to the confirmation password
		marks.push(new MarkedField({
			el: form.$('[name=confirmPassword]'),
			validator: _.concat(validator, this._match.bind(this,form))
		}).render())

		return marks
	},

	/**
	 * returns an error message if the passwords don't match
	 */
	_match: function(form) {
		var password = form.$('[name=password]').val()
		var confirmPassword = form.$('[name=confirmPassword]').val()
		if (password !== confirmPassword) {
			return i18n.get('common.error.passwordsMustMatch')
		}
	}
}

export default passwordValidation

passwordValidation.__filename__ = 'components/password-validation.js'
